// 펜 두께 (px)
export const CANVAS_BRUSH_WIDTH_XXS = 1.5;
export const CANVAS_BRUSH_WIDTH_XS = 2;
export const CANVAS_BRUSH_WIDTH_S = 3;
export const CANVAS_BRUSH_WIDTH_M = 5;
export const CANVAS_BRUSH_WIDTH_L = 8;

// 픽셀 지우개 두께 (px)
export const CANVAS_PIXEL_ERASER_WIDTH_S = 8;
export const CANVAS_PIXEL_ERASER_WIDTH_M = 10;
export const CANVAS_PIXEL_ERASER_WIDTH_L = 12;

// 객체 지우개가 사용되는 격자 사이즈
// 값이 작을수록 격자가 더 세밀해지고 정밀도가 높아지지만, 메모리 사용과 계산량이 증가
export const OBJECT_ERASER_SIZE = 10;

// 기본값 : 0.4
// 숫자를 넣어야 하고 소숫점 가능
// 숫자가 낮아질 수록 부드러워짐, 성능 저하 가능
export const CANVAS_BRUSH_DECIMATE = 1;